import { RouteType } from "../@types/RouteType";
import { 
    DashboardRoutes, 
    OrderRoutesWInventory, 
    RegistrationRoutes, 
    WarrantyClaimRoutes, 
    TechSupportRoutes, 
    LeadsRoutes, 
    ResourcesRoutes, 
    GeneralRoutes, 
} from "./MainRoutes";

const DealerSalesRoutes: RouteType[] = [
    ...DashboardRoutes,
    ...OrderRoutesWInventory,
    ...RegistrationRoutes,
    ...WarrantyClaimRoutes,
    ...TechSupportRoutes,
    ...LeadsRoutes,
    ...ResourcesRoutes,
    ...GeneralRoutes
]

export default DealerSalesRoutes;